export const selectedSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path d="M2.29395 8.69341L5.90195 12.05L13.0039 5.16663" stroke="#2B74D8" stroke-width="1.5" stroke-linecap="square" />
    </svg>
  )
}

export const minusSvg = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M2 8H14" stroke={color} stroke-width="1.5" />
    </svg>
  )
}

export const plusSvg = (color) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8.74868 7.25132V2H7.25132V7.25132H2V8.74868H7.25132V14H8.74868V8.74868H14V7.25132H8.74868Z" fill={color} />
    </svg>
  )
}

export const crossSvg = () => (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
  <g opacity="0.7">
    <path d="M9.89983 3.41985L9.12283 2.64285L6.04269 5.723L2.96255 2.64285L2.18555 3.41985L5.26569 6.5L2.18555 9.58014L2.96255 10.3571L6.04269 7.27699L9.12283 10.3571L9.89983 9.58014L6.81969 6.5L9.89983 3.41985Z" fill="#111C36" />
  </g>
</svg>)

export const filterIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <rect width="16" height="16" transform="translate(0.75 0.400391)" fill="white" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2502 3.40649C10.0466 3.40649 9.03447 4.27524 8.80103 5.42049H2.25024C1.9741 5.42049 1.75024 5.64592 1.75024 5.92399C1.75024 6.20206 1.9741 6.42749 2.25024 6.42749H8.80103C9.03447 7.57275 10.0466 8.44149 11.2502 8.44149C12.4538 8.44149 13.466 7.57275 13.6995 6.42749H15.2502C15.5264 6.42749 15.7502 6.20206 15.7502 5.92399C15.7502 5.64592 15.5264 5.42049 15.2502 5.42049H13.6995C13.466 4.27524 12.4538 3.40649 11.2502 3.40649ZM11.2502 4.41349C12.0846 4.41349 12.7502 5.08382 12.7502 5.92399C12.7502 6.76417 12.0846 7.43449 11.2502 7.43449C10.4159 7.43449 9.75024 6.76417 9.75024 5.92399C9.75024 5.08382 10.4159 4.41349 11.2502 4.41349Z" fill="#111C36" />
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.25024 8.44153C5.04665 8.44153 4.03447 9.31027 3.80103 10.4555H2.25024C1.9741 10.4555 1.75024 10.681 1.75024 10.959C1.75024 11.2371 1.9741 11.4625 2.25024 11.4625H3.80103C4.03447 12.6078 5.04665 13.4765 6.25024 13.4765C7.45384 13.4765 8.46602 12.6078 8.69946 11.4625H15.2502C15.5264 11.4625 15.7502 11.2371 15.7502 10.959C15.7502 10.681 15.5264 10.4555 15.2502 10.4555H8.69946C8.46602 9.31027 7.45384 8.44153 6.25024 8.44153ZM6.25024 9.44853C7.08458 9.44853 7.75024 10.1189 7.75024 10.959C7.75024 11.7992 7.08458 12.4695 6.25024 12.4695C5.41591 12.4695 4.75024 11.7992 4.75024 10.959C4.75024 10.1189 5.41591 9.44853 6.25024 9.44853Z" fill="#111C36" />
</svg>)

export const leftArrow = (fill) => (<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <g clip-path="url(#clip0_1537_4746)">
    <path d="M16.8999 6.2625L11.3371 12L16.8999 17.7375L15.1874 19.5L7.8999 12L15.1874 4.5L16.8999 6.2625Z" fill={fill} />
  </g>
  <defs>
    <clipPath id="clip0_1537_4746">
      <rect width="24" height="24" fill="white" transform="matrix(0 1 -1 0 24.3999 0)" />
    </clipPath>
  </defs>
</svg>)

export const rightArrow = (fill) => (<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <g clip-path="url(#clip0_1537_4750)">
    <path d="M7.8999 6.2625L13.4627 12L7.8999 17.7375L9.61245 19.5L16.8999 12L9.61245 4.5L7.8999 6.2625Z" fill={fill} />
  </g>
  <defs>
    <clipPath id="clip0_1537_4750">
      <rect width="24" height="24" fill="white" transform="matrix(0 1 1 0 0.399902 0)" />
    </clipPath>
  </defs>
</svg>)
